import { c as _c } from "react/compiler-runtime";
import { useMediaQueryList } from "@hooks/use-media-query";
import { Box } from "@mui-wrapper";
import { OpenProjectButton } from "@pages/project-details/open-project-button";
import { ProjectOverviewActionButtons } from "@pages/project-details/project-overview/project-overview-action-buttons";
import { ResponsiveProjectButtons } from "@pages/project-details/responsive-project-buttons";
import { hasDescribeOnlyPermission } from "@utils/permission-control/project-permission-control";
import { shouldHideOpenProject } from "@utils/project-utils";
import { useMemo } from "react";
/**
 * Provides buttons for project details page.
 * On larger screens, shows all buttons normally.
 * On smaller screens, shows a compact version with archive/share/delete in a three dot dropdown menu.
 */
export function ProjectButtons(t0) {
  const $ = _c(26);
  const {
    project,
    isLoading,
    tabControl
  } = t0;
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  let t1;
  if ($[0] !== project) {
    t1 = shouldHideOpenProject(project);
    $[0] = project;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const shouldHideOpenProjectButton = t1;
  let t2;
  if ($[2] !== tabControl) {
    t2 = tabControl && <Box sx={{
      mr: "auto"
    }}>{tabControl}</Box>;
    $[2] = tabControl;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const tabControlWithSpacing = t2;
  if (hasDescribeOnlyPermission(project)) {
    return tabControlWithSpacing || null;
  }
  if (!isScreenSmOrSmaller) {
    let t3;
    if ($[4] !== isLoading || $[5] !== project) {
      t3 = !isLoading && <ProjectOverviewActionButtons project={project} />;
      $[4] = isLoading;
      $[5] = project;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== isLoading || $[8] !== project || $[9] !== shouldHideOpenProjectButton) {
      t4 = !shouldHideOpenProjectButton && <OpenProjectButton project={project} isLoading={isLoading} />;
      $[7] = isLoading;
      $[8] = project;
      $[9] = shouldHideOpenProjectButton;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    let t5;
    if ($[11] !== t3 || $[12] !== t4 || $[13] !== tabControlWithSpacing) {
      t5 = <>{tabControlWithSpacing}{t3}{t4}</>;
      $[11] = t3;
      $[12] = t4;
      $[13] = tabControlWithSpacing;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    return t5;
  }
  let t3;
  if ($[15] !== isLoading || $[16] !== project || $[17] !== shouldHideOpenProjectButton) {
    t3 = !shouldHideOpenProjectButton && <OpenProjectButton project={project} isLoading={isLoading} />;
    $[15] = isLoading;
    $[16] = project;
    $[17] = shouldHideOpenProjectButton;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  let t4;
  if ($[19] !== isLoading || $[20] !== project) {
    t4 = !isLoading && <ResponsiveProjectButtons project={project} />;
    $[19] = isLoading;
    $[20] = project;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  let t5;
  if ($[22] !== t3 || $[23] !== t4 || $[24] !== tabControlWithSpacing) {
    t5 = <>{tabControlWithSpacing}{t3}{t4}</>;
    $[22] = t3;
    $[23] = t4;
    $[24] = tabControlWithSpacing;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  return t5;
}